import React from 'react'
import { useSelector } from 'react-redux'
import Navbar from '../Navbar/Navbar'
import AdvertiseWidget from './AdvertiseWidget'
import FriendsWidget from './FriendsWidget'
import MyPostWidget from './MyPostWidget'
import PostsWidget from './PostsWidget'
import UserWidgets from './UserWidgets'

const HomePage = () => {
  const {_id, picturePath}=useSelector((state)=>state.app.user)
  return (
    <div className='w-full flex flex-col gap-6 dark:bg-[#3D3B3B] '>
        <Navbar/>
        <div className='w-full flex xs:flex-col xs:items-center justify-center gap-6 xs:pr-6 pl-6'>
          <div className='w-[25%] xs:w-full min-w-min xs:max-w-[500px] '>
          <UserWidgets userId={_id} picturePath={picturePath}/>
          </div>
          <div className='w-[40%] xs:w-full xs:max-w-[500px] min-w-min flex flex-col gap-2'>
          <MyPostWidget picturePath={picturePath}/>
          <PostsWidget userId={_id} />
          </div>
          <div className=" w-[25%] xs:w-full xs:max-w-[500px] flex flex-col xs:items-center gap-4 sticky ">
            <AdvertiseWidget/>
            <FriendsWidget userId={_id}/>
          </div>
          
        </div>
    </div>
  )
}

export default HomePage